import { gql } from "@apollo/client";

export const uploadFile = gql`
    mutation uploadFile($fileType: FileMetadataFileType!, $file: Upload!) {
        uploadFile(input: { fileType: $fileType, file: $file }) {
            uploadRefId
        }
    }
`;
